import React, { useState } from 'react';
import Select from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import Tooltip from '@mui/joy/Tooltip';

export default function ParitySelector(props) {
    const { value, onChange, locked, toolTip } = props;
    const [toolTipParity, setToolTipParity] = useState(true);
    return (
    <Tooltip title={toolTipParity ? toolTip: null}>
        <Select value={value ? value : 0} onChange={onChange} Value={value ? value : 1} disabled={locked}placeholder="Parity" onListboxOpenChange={() => setToolTipParity(!toolTipParity)} >
        <Option value={1}>+</Option>
        <Option value={-1}>-</Option>
        </Select>
    </Tooltip>
    );
}